module.exports = {
	"generation": 12,
	"links_in_ad": 3,
	"items": [
		{
			"id": 44820,
			"name": "Audio Mastering",
			"url": "https://studio.envato.com/explore/mixing-mastering/44820-audio-mastering",
			"price_from": 90
		},
		{
			"id": 9314,
			"name": "1 Minute Explainer Animation plus Voice Over and Music",
			"url": "https://studio.envato.com/explore/explainer-videos/9314-explainer-animation-1-minute-voice-over-and-music",
			"price_from": 1500
		},
		{
			"id": 44881,
			"name": "Professional Female Voice Over Talent",
			"url": "https://studio.envato.com/explore/voice-overs/44881-professional-female-voice-over-talent",
			"price_from": 100
		},
		{
			"id": 44937,
			"name": "Profesional Guitar and Bass Tracking",
			"url": "https://studio.envato.com/explore/session-musicians/44937-profesional-guitar-and-bass-tracking",
			"price_from": 125
		},
		{
			"id": 38271,
			"name": "Up to 30 Second Voice Over",
			"url": "https://studio.envato.com/explore/voice-overs/38271-up-to-30-second-voice-over-male-american-english",
			"price_from": 50
		},
		{
			"id": 44912,
			"name": "Audio Editing For Any Type Of Project",
			"url": "https://studio.envato.com/explore/audio-editing/44912-audio-editing-for-any-type-of-project",
			"price_from": 40
		},
		{
			"id": 45370,
			"name": "In-Vision Explainer HD Videos shot in a Virtual Newsroom Studio",
			"url": "https://studio.envato.com/explore/explainer-videos/45370-in-vision-explainer-hd-videos-shot-in-a-virtual-newsroom-studio",
			"price_from": 275
		},
		{
			"id": 3335,
			"name": "Speed up WordPress PageSpeed",
			"url": "https://studio.envato.com/explore/wordpress-speed-optimization/3335-speed-up-wordpress-pagespeed",
			"price_from": 100
		},
		{
			"id": 44805,
			"name": "Soundtrack Production for Movies, Games and more",
			"url": "https://studio.envato.com/explore/music-production/44805-soundtrack-production-movies-games-more",
			"price_from": 320
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./config/sites/studio-recommendations/audiojungle.json
// module id = 486
// module chunks = 1